import React from 'react';
import NotificationIcon from '../assets/notification.svg';


function NotificationIconContent() {
    return <input type="image" alt='powiadomienie' src={NotificationIcon} />

}

export default NotificationIconContent;